<template>
  <div class="signup">
    <div class="page">
      <Email v-if="currentComponent === 'Email'"
        @submit="emailAddress => registerEmail(emailAddress)"
        :show-email-verification-failure="showEmailVerificationFailure"
        :backend-error-message="backendErrorMessage"
        :is-campaign-trial="isCampaignTrial"
        :is-light-trial="isLightTrial"
      />

      <CheckEmail v-if="currentComponent === 'CheckEmail'"
        :email-address-to-check="emailAddressToCheck"
        :is-ui-only-mode="isUiOnlyMode"
        :trial-type-for-ui-only-mode="trialType"
      />

      <NamePassword v-if="currentComponent === 'NamePassword'"
        @submit="params => createAccount(params)"
        :current-step="currentStep"
        :number-of-steps="numberOfSteps"
        :is-campaign-trial="isCampaignTrial"
      />
    </div>
  </div>
</template>

<script>
import {
  IS_UI_ONLY_MODE,
  LIGHT_TRIAL_TYPE_KEY,
  ELEARNING_TRIAL_TYPE_KEY,
  CAMPAIGN_TRIAL_TYPE_KEY
} from '@/main.js'
import { registerEmail, verifyEmail, createAccount } from '@/api/member_registration.js';
import Email from '@/components/signup/Email.vue'
import CheckEmail from '@/components/signup/CheckEmail.vue'
import NamePassword from '@/components/signup/NamePassword.vue'

export default {
  name: 'Signup',

  components: {
    Email,
    CheckEmail,
    NamePassword
  },

  props: {
    emailAddressToVerify: {
      type: String,
      required: true
    },

    tokenToVerify: {
      type: String,
      required: true
    },

    trialType: {
      type: String,
      required: true,
      validator: value => [LIGHT_TRIAL_TYPE_KEY, ELEARNING_TRIAL_TYPE_KEY, CAMPAIGN_TRIAL_TYPE_KEY].includes(value)
    },

    miscUrlParams: {
      type: Object,
      default: null
    },
  },

  data() {
    return {
      currentComponent: "Email",

      emailAddressToCheck: '',

      showEmailVerificationFailure: false,

      backendErrorMessage: ''
    }
  },

  computed: {
    currentStep() {
      return 1
    },

    numberOfSteps() {
      return this.isElearningTrial || this.isCampaignTrial ? 3 : 2
    },

    isLightTrial() {
      return this.trialType === LIGHT_TRIAL_TYPE_KEY
    },

    isElearningTrial() {
      return this.trialType === ELEARNING_TRIAL_TYPE_KEY
    },

    isCampaignTrial() {
      return this.trialType === CAMPAIGN_TRIAL_TYPE_KEY
    },

    isUiOnlyMode() {
      return IS_UI_ONLY_MODE
    }
  },

  async created() {
    if (this.emailAddressToVerify && this.tokenToVerify && this.trialType) {
      this.$emit('loaded', false)
      this.$emit('processing', true)
      const isSuccessful = await verifyEmail(this.emailAddressToVerify, this.tokenToVerify, this.trialType)
      if (isSuccessful) {
        this.currentComponent = "NamePassword"
        this.$emit('verified', this.emailAddressToVerify)
      } else {
        this.showEmailVerificationFailure = true
      }
      this.$emit('loaded', true)
      this.$emit('processing', false)
    }
  },

  methods: {
    async registerEmail(emailAddress) {
      this.backendErrorMessage = ""
      this.$emit('processing', true)
      const {isSuccessful, statusMessage} = await registerEmail(emailAddress, this.trialType, this.miscUrlParams)
      this.$emit('processing', false)
      if (isSuccessful) {
        this.emailAddressToCheck = emailAddress
        this.currentComponent = "CheckEmail"
      } else {
        this.backendErrorMessage = statusMessage
      }
    },

    async createAccount(params) {
      const { 
        nickname, password, phoneNumber, couponCode } = params
      this.$emit('processing', true)
      const isSuccessful = await createAccount({
        userId: this.emailAddressToVerify,
        nickname,
        password,
        phoneNumber,
        couponCode,
        trialType: this.trialType
      })
      this.$emit('processing', false)
      if (isSuccessful) {
        this.$emit('processing', true, true, "アカウントを作成していますので、", "しばらくお待ちください。")
        setTimeout(() => {
          this.$emit('processing', false)
          this.$emit('registered')
        }, 5000)
      }
    }
  }
}
</script>

<style scoped>
.signup .page {
  margin: 40px 0 60px;
}

@media (max-width: 768px) {
  .signup .page {
    margin: 40px 20px 60px;
  }
}
</style>
